import { useCallback, useRef, useState } from 'react'

export default function usePoll(callback, delay) {
  const timeoutRef = useRef()
  const [isPolling, setIsPolling] = useState(false)
  // Always use the latest callback without restarting the interval
  const callbackRef = useRef(callback)
  callbackRef.current = callback

  const stopPolling = useCallback(() => {
    clearInterval(timeoutRef.current)
    timeoutRef.current = null
    setIsPolling(false)
  }, [])

  const startPolling = useCallback(() => {
    // Clear any existing interval — prevents duplicate intervals if called multiple times
    clearInterval(timeoutRef.current)

    const tick = () => {
      callbackRef.current(stopPolling)
    }

    setIsPolling(true)
    // Fire after first delay (give backend time to start processing), then repeat every `delay` ms
    timeoutRef.current = setInterval(tick, delay)
  }, [delay, stopPolling])

  return {
    startPolling,
    stopPolling,
    isPolling,
  }
}
